var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4-fullhd"},[_c('overview',{attrs:{"project":_vm.project}})],1),_c('div',{staticClass:"column is-3-fullhd"},[_c('export',{attrs:{"project":_vm.project}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }